:host {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  margin-left: auto;
  margin-right: auto;
  font-family: var(--cwc-font-sans-serif-regular, 'Eina01-Regular');
}
